// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer--2S2Ll","footerList":"footerList--1-WgR","item":"item--2g7hK","desc":"desc--25gYs","btn":"btn--_PnYz","footerBottom":"footerBottom--2Zh-u"};